(() => {
  const ROOT_CANDIDATES = ['.price_per_kit_solo_toggle #order-now-section'];
  const ITEM_SELECTOR = '.price_per_kit_solo_toggle .order-nowItem';
  const TOGGLE_WRAP_SELECTOR = '.price_per_kit_solo_toggle .purchase-toggle';
  const TOGGLE_INPUT_SELECTOR = '.price_per_kit_solo_toggle .toggle__input';

  const PER_KIT_SELECTOR = '.price_per_kit_solo_toggle .new-pricing .per-kit b .money';
  const TOTAL_SELECTOR = '.price_per_kit_solo_toggle .new-pricing .total-to-pay > b .money';
  const SAVING_SELECTOR = '.price_per_kit_solo_toggle .new-pricing .total-to-pay .saving .money';
  const COMPARE_SELECTOR = '.price_per_kit_solo_toggle .new-pricing .total-to-pay .compare .money';
  const MONEY_FALLBACK = '.price_per_kit_solo_toggle .money';

  const SUBMIT_BTN_SELECTOR = '.price_per_kit_solo_toggle .product-form__submit';
  const QTY_SELECTOR = '.price_per_kit_solo_toggle .quantity__input';
  const REDIRECT_MODE = 'always';

  const getRoot = () => {
    for (const s of ROOT_CANDIDATES) {
      const el = document.querySelector(s);
      if (el) return el;
    }
    return null;
  };

  const num = (v) => {
    if (v == null) return NaN;
    return parseFloat(String(v).replace(/[^\d.]/g, ''));
  };

  const fmtMoneyLike = (value, exampleEl, decimals = 2) => {
    const path = window.location.pathname || '';
    const n = Number(value);

    if (!exampleEl || !isFinite(n)) return '';

    const sample = exampleEl.textContent.replace(/undefined/gi, '').trim();
    const m = sample.match(/[\d.,]+/);
    if (!m) return '';

    const [numStr] = m;
    const pref = sample.slice(0, sample.indexOf(numStr));
    const suf = sample.slice(sample.indexOf(numStr) + numStr.length);
    const fixed = decimals === 0 ? String(Math.round(n)) : n.toFixed(decimals);

    if (path.includes('/en-ca/') || path.includes('/en-au/')) {
      return `${pref}${fixed}${suf}`.trim();
    }

    return `${pref}${fixed}`.trim();
  };

  const ensureHiddenInput = (formEl, name, value) => {
    let input = formEl.querySelector(`input[name="${name}"]`);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      formEl.appendChild(input);
    }
    input.value = value;
    return input;
  };

  const removeHiddenInput = (formEl, name) => {
    const el = formEl.querySelector(`input[name="${name}"]`);
    if (el) el.remove();
  };

  const getAttr = (el, base, idx) => el.getAttribute(`data-${base}-${idx}`);

  const updatePricingForItem = (itemEl, idx1, isSubs, wrap) => {
    const perKitEl = itemEl.querySelector(PER_KIT_SELECTOR);
    const totalEl = itemEl.querySelector(TOTAL_SELECTOR);
    const savingEl = itemEl.querySelector(SAVING_SELECTOR);
    const compareEl = itemEl.querySelector(COMPARE_SELECTOR);
    if (!wrap) return;

    const onetimePrice = num(getAttr(wrap, 'onetime-price', idx1));
    const subsPrice    = num(getAttr(wrap, 'subscribe-save', idx1));
    const saveOnetime  = num(getAttr(wrap, 'saving-onetime', idx1));
    const saveSubs     = num(getAttr(wrap, 'saving-subs', idx1));
    const onetimeCompare = num(getAttr(wrap, 'onetime-compare', idx1));
    const subsCompare    = num(getAttr(wrap, 'subs-compare', idx1));

    const example = perKitEl || totalEl || savingEl || itemEl.querySelector(MONEY_FALLBACK);

    const basePrice   = isSubs ? subsPrice : onetimePrice;
    const perKitPrice = basePrice / idx1;
    const savingVal   = isSubs ? saveSubs : saveOnetime;
    const compareVal  = isSubs ? subsCompare : onetimeCompare;

    const updateText = (el, value, decimals = 2) => {
      if (!el) return
      const formatted = fmtMoneyLike(value, example, decimals)
      if (formatted) el.textContent = formatted
    }

    updateText(perKitEl, perKitPrice, 2)
    updateText(totalEl, basePrice, 2)
    updateText(savingEl, Math.round(savingVal), 0)
    updateText(compareEl, compareVal, 2)

    itemEl.classList.toggle('subs', isSubs);
  };

  const getSubmitForm = (itemEl) => {
    const btn = itemEl.querySelector(SUBMIT_BTN_SELECTOR);
    return btn ? btn.closest('form') : null;
  };

  const syncFormForItem = (itemEl, idx1, isSubs, wrap) => {
    const formEl = getSubmitForm(itemEl);
    if (!formEl || !wrap) return;

    const variantId     = getAttr(wrap, 'variant-id', idx1) || '';
    const sellingPlanId = getAttr(wrap, 'subscribe-plan', idx1) || '';

    if (variantId) ensureHiddenInput(formEl, 'id', variantId);

    if (isSubs && sellingPlanId) ensureHiddenInput(formEl, 'selling_plan', sellingPlanId);
    else removeHiddenInput(formEl, 'selling_plan');

    if (REDIRECT_MODE === 'always' || (REDIRECT_MODE === 'subsOnly' && isSubs)) {
      ensureHiddenInput(formEl, 'return_to', '/checkout');
    } else {
      removeHiddenInput(formEl, 'return_to');
    }

    const qtyEl = itemEl.querySelector(QTY_SELECTOR);
    if (qtyEl) ensureHiddenInput(formEl, 'quantity', String(qtyEl.value || 1));
  };

  const updateAllItems = (root, isSubs) => {
    const wrap = root.querySelector(TOGGLE_WRAP_SELECTOR);
    const items = Array.from(root.querySelectorAll(ITEM_SELECTOR));
    root.classList.toggle('is-sub', isSubs);
    items.forEach((itemEl, i) => {
      const idx1 = parseInt(itemEl.dataset.cardIndex, 10) || (i + 1);
      updatePricingForItem(itemEl, idx1, isSubs, wrap);
      syncFormForItem(itemEl, idx1, isSubs, wrap);
    });
  };

  const initQtySync = (root) => {
    const wrap = root.querySelector(TOGGLE_WRAP_SELECTOR);
    const items = Array.from(root.querySelectorAll(ITEM_SELECTOR));
    items.forEach((itemEl, i) => {
      const idx1 = parseInt(itemEl.dataset.cardIndex, 10) || (i + 1);
      const qtyEl = itemEl.querySelector(QTY_SELECTOR);
      if (!qtyEl || qtyEl.dataset.syncInit === '1') return;
      qtyEl.dataset.syncInit = '1';
      const resync = () => {
        const toggle = root.querySelector(TOGGLE_INPUT_SELECTOR);
        const isSubs = !!toggle?.checked;
        syncFormForItem(itemEl, idx1, isSubs, wrap);
      };
      qtyEl.addEventListener('input', resync);
      qtyEl.addEventListener('change', resync);
    });
  };

  const forceDefaultChecked = (root) => {
    const toggle = root.querySelector(TOGGLE_INPUT_SELECTOR);
    if (toggle && !toggle.checked) toggle.checked = true;
    updateAllItems(root, true);
  };

  const initialize = () => {
    const root = getRoot();
    if (!root) return false;

    const toggle = root.querySelector(TOGGLE_INPUT_SELECTOR);
    if (!toggle) return false;

    forceDefaultChecked(root);
    initQtySync(root);

    if (!toggle.dataset.bound) {
      toggle.dataset.bound = '1';
      toggle.addEventListener('change', () => {
        const isSubs = !!toggle.checked;
        updateAllItems(root, isSubs);
      });
    }

    window.updateSoloToggle = (isSubs) => {
      const currentRoot = getRoot();
      if (currentRoot) updateAllItems(currentRoot, isSubs);
    };


    const items = Array.from(root.querySelectorAll(ITEM_SELECTOR));
    items.forEach((itemEl, i) => {
      const formEl = getSubmitForm(itemEl);
      if (!formEl || formEl.dataset.bound) return;
      formEl.dataset.bound = '1';
      formEl.addEventListener('submit', () => {
        const isSubs = !!toggle.checked;
        const wrap = root.querySelector(TOGGLE_WRAP_SELECTOR);
        const idx1 = parseInt(itemEl.dataset.cardIndex, 10) || (i + 1);
        syncFormForItem(itemEl, idx1, isSubs, wrap);
      });
    });

    return true;
  };

  if (!initialize()) {
    let tries = 0, max = 180;
    const tick = () => {
      if (initialize()) return;
      if (tries++ < max) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }

  window.addEventListener('pageshow', () => {
    const root = getRoot();
    if (root) forceDefaultChecked(root);
  });
})();